import { defineMessages } from 'react-intl';

export default defineMessages({
    totalCost: {
        id: 'e1p.gateway.view.policy-detail-summary.Total Cost',
        defaultMessage: 'Total Cost'
    }
});
